// extracted by mini-css-extract-plugin
export default {"p_tye":"d63850231e","slcted":"a9382bc2ef","slc_color":"_153ae84029","item_p":"d419cab0dc","r0":"_4f1d256127"};